<script lang="ts">
	import { Alert } from '@Shelly/shelly-design-system/index';
	import { format } from 'svelte-i18n';
	import { MAX_CARDS_IN_WIDGET } from '../../dash-helpers';

	export let counter: number;
	export let limit: number = MAX_CARDS_IN_WIDGET;

	$: disabledSelectCard = counter >= limit;
</script>

<Alert
	class="mb-l"
	type={!disabledSelectCard ? 'info' : 'warning'}
	heading={$format('alert_heading_items_selected', {
		values: {
			count: counter,
			limit,
		},
		default: `Items selected: {count}/{limit}`,
	})}
	message={$format('alert_message_items_selected', {
		values: {
			limit,
		},
		default: `Select up to {limit} items.`,
	})}
	isHeadingBold
/>
